module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-pool.svg?7cca9a85ea2e3a3a7e9bce1a0d36f570";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-pool.svg
// module id = 1043
// module chunks = 1